import React from "react";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Kayannou - Free Online Unit Converter Tools | Area, Length, Weight, Temperature</title>
        <meta name="description" content="Free online unit conversion tools for area, length, speed, temperature, time, volume, and weight. Convert between meters, feet, pounds, kilograms, celsius, fahrenheit, and more. Fast, accurate, and easy-to-use converters." />
        <meta name="keywords" content="unit converter, conversion calculator, area converter, length converter, temperature converter, measurement tools, free converter, online calculator, metric conversion, imperial conversion, convert units" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kayannou.com/" />
        <meta name="author" content="Kayannou" />
        <meta property="og:title" content="Kayannou - Free Online Unit Converter Tools" />
        <meta property="og:description" content="Free online unit conversion tools for area, length, speed, temperature, time, volume, and weight. Fast, accurate, and easy-to-use." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://kayannou.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kayannou - Free Online Unit Converter Tools" />
        <meta name="twitter:description" content="Free online unit conversion tools for area, length, speed, temperature, time, volume, and weight." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Kayannou Unit Converter",
            "description": "Free online unit conversion tools for area, length, speed, temperature, time, volume, and weight",
            "url": "https://kayannou.com/",
            "applicationCategory": "UtilityApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "featureList": [
              "Area Conversion",
              "Length Conversion",
              "Speed Conversion",
              "Temperature Conversion",
              "Time Conversion",
              "Volume Conversion",
              "Weight Conversion"
            ]
          })}
        </script>
      </Helmet>

      <div className="content-section">
        <header className="w3-container w3-center">
          <h1 className="w3-text-orange w3-jumbo">KAYANNOU</h1>
          <p className="w3-large w3-text-gray">Professional Unit Conversion Tools</p>
          <p className="w3-text-gray">Convert between different units quickly and accurately with our free online calculators.</p>
        </header>
      </div>

      <div className="content-section">
        <div className="w3-row w3-container w3-margin home-card-row">
          <div className="w3-third">
            <Link to="/conversion/area" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-expand w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Area Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Square meters, acres, hectares, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to="/conversion/length" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-arrows-h w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Length Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Meters, feet, inches, kilometers, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to="/conversion/speed" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-tachometer w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Speed Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">MPH, KPH, knots, mach, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="w3-row w3-container w3-margin home-card-row">
          <div className="w3-third">
            <Link to="/conversion/temperature" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-thermometer-half w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Temperature Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Celsius, Fahrenheit, Kelvin, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to="/conversion/time" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-clock-o w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Time Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Seconds, minutes, hours, days, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <Link to="/conversion/volume" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-cube w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Volume Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Liters, gallons, cubic meters, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="w3-row w3-container w3-margin home-card-row">
          <div className="w3-third">
            <Link to="/conversion/weight" className="w3-text-decoration-none">
              <div className="w3-dark-gray w3-text-orange w3-hover-shadow w3-center w3-margin w3-hover-text-white w3-card-4 conversion-card">
                <div className="conversion-card-content">
                  <div className="conversion-card-icon">
                    <i className="fa fa-balance-scale w3-xxxlarge"></i>
                  </div>
                  <div className="conversion-card-title">
                    <h3>Weight Conversion</h3>
                  </div>
                  <div className="conversion-card-description">
                    <p className="w3-text-light-gray">Kilograms, pounds, ounces, and more</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="w3-third">
            <div className="w3-light-gray w3-center w3-margin w3-card-4 conversion-card">
              <div className="conversion-card-content">
                <div className="conversion-card-icon">
                  <i className="fa fa-plus w3-xxxlarge w3-text-gray"></i>
                </div>
                <div className="conversion-card-title">
                  <h3 className="w3-text-gray">More Tools</h3>
                </div>
                <div className="conversion-card-description">
                  <p className="w3-text-gray">Additional converters coming soon</p>
                </div>
              </div>
            </div>
          </div>
          <div className="w3-third">
            {/* Empty space or future content */}
          </div>
        </div>
      </div>

      <div className="content-section">
        <div className="w3-container w3-center w3-margin-top">
          <h2 className="w3-text-orange">Why Choose Kayannou?</h2>
          <div className="w3-row w3-margin-top">
            <div className="w3-third">
              <div className="w3-padding">
                <i className="fa fa-bolt w3-xxlarge w3-text-orange"></i>
                <h4>Fast & Accurate</h4>
                <p>Instant conversions with precise calculations for all your measurement needs.</p>
              </div>
            </div>
            <div className="w3-third">
              <div className="w3-padding">
                <i className="fa fa-mobile w3-xxlarge w3-text-orange"></i>
                <h4>Mobile Friendly</h4>
                <p>Works perfectly on all devices - desktop, tablet, and mobile phones.</p>
              </div>
            </div>
            <div className="w3-third">
              <div className="w3-padding">
                <i className="fa fa-gift w3-xxlarge w3-text-orange"></i>
                <h4>Always Free</h4>
                <p>No registration required. Use all our conversion tools completely free.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
